import { render, staticRenderFns } from "./lead-box.vue?vue&type=template&id=259dc7b5&scoped=true&"
import script from "./lead-box.vue?vue&type=script&lang=js&"
export * from "./lead-box.vue?vue&type=script&lang=js&"
import style0 from "./lead-box.vue?vue&type=style&index=0&id=259dc7b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259dc7b5",
  null
  
)

export default component.exports